import React from "react";

function LinkForm({ name, url }) {
  const openLink = () => {
    window.open(url, name);
  };
  return (
    <>
      {/* <div className="border p-2 mb-4 card-safy">
        <div className="h6 ms-4">
          {name}
          <i
            className="fas fa-plus-circle float-end p-1 text-primary"
            onClick={openLink}
          />
        </div>
      </div> */}
      <div className="d-inline-flex mb-2 ms-4" role="button" onClick={openLink}>
        <div className="rounded bg-primary text-white px-2 me-1">Link</div>
        <div className="text-primary">{name}</div>
      </div>
    </>
  );
}

export default LinkForm;
